"use client";
import { Typography } from "antd";
import React from "react";

import BestChoiceSlider from "./bestChoiceSlider";
const { Title } = Typography;

const BestChoice = () => {
  return (
    <div className="flex flex-col gap-8 justify-center items-center">
      <div className="flex flex-col">
        <Title level={2} className="H2 text-center">
          چرا ما بهترین انتخابیم؟
        </Title>
        <p className="text-regal-black-lighter text-center ">
          تفاوت ما در تعهد، کیفیت و نتایجی که برای شما رقم می‌زنیم، است.
        </p>
      </div>
      <div className="w-full flex items-start justify-center max-w-[58rem] h-[22rem] sm:h-[25rem] md:h-[29rem] xl:h-[32rem]">
        <BestChoiceSlider />
      </div>
    </div>
  );
};

export default BestChoice;
